import { LoggedUser } from './../core/logged/logged.model';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { ItinActionService } from '../core/itinerari/itinerari.action';
import { PaginatedItin } from '../shared/models/paginated-itin.model';

@Injectable()
export class ItinListAdminResolver implements Resolve<any> {
  @select(['logged', 'logged'])
  userLogged$: Observable<LoggedUser>;

  constructor(private service: ApiService,
              private itinAction: ItinActionService) {}

  resolve() {
    return this.userLogged$.pipe(
      first(),
      mergeMap((user: LoggedUser) => {
        const geoposId = user.auth_user === 'superadmin' ? null : user.geopos[0].id;
        return this.service.getItin(
          0,
          geoposId,
          null,
          null,
          null,
          true
        ).pipe(first());
      }),
      tap((paginatedItin: PaginatedItin) => {
        this.itinAction.paginatedItinList(paginatedItin);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di itinerari');
        return of(err);
      })
    );
  }
}
